import { DeleteOutlined } from "@ant-design/icons";
import { Button, Empty, Form, Popconfirm, Typography, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { serverUrl } from "../../../../../nestserver";
import CreateTemplateModal from "./modals/CreateTemplateModal";

const { Text, Title } = Typography;

const AnnouncementTemplates = () => {
  const [templateForm] = Form.useForm();
  const [templates, setTemplates] = useState([]);
  const [createModalVisible, setCreateModalVisible] = useState(false);

  const fetchTemplates = async () => {
    try {
      const res = await axios.get(
        serverUrl + "/personal-messages/announcement-meta",
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        },
      );
      setTemplates(res.data?.result?.templates || []);
    } catch (err) {
      console.error("Failed to fetch templates", err);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const insertTag = (tag) => {
    const currentContent = templateForm.getFieldValue("content") || "";
    templateForm.setFieldsValue({
      content: currentContent + (currentContent ? " " : "") + tag,
    });
  };

  const handleCreateTemplate = async (values) => {
    try {
      await axios.post(serverUrl + "/message-templates", values, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      });
      message.success("Template created");
      templateForm.resetFields();
      setCreateModalVisible(false);
      fetchTemplates();
    } catch (err) {
      message.error("Failed to create template");
    }
  };

  const handleDeleteTemplate = async (id) => {
    try {
      await axios.delete(serverUrl + "/message-templates/" + id, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      });
      message.success("Template deleted");
      fetchTemplates();
    } catch (err) {
      message.error("Failed to delete template");
    }
  };

  return (
    <div className="mt-8">
      <div
        style={{ borderRadius: "10px", color: "#616161", overflowY: "auto" }}
        className="bg-white drop-shadow-md p-8 w-full screen-height"
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold m-0 text-gray-800">
            Message Templates
          </h2>
          <Button type="primary" onClick={() => setCreateModalVisible(true)}>
            + New Template
          </Button>
        </div>

        <Title level={5} style={{ marginBottom: 12 }}>
          Saved Templates ({templates.length})
        </Title>

        <div style={{ maxWidth: 640 }}>
          {templates.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No templates yet. Create one to get started."
            />
          ) : (
            templates.map((t) => (
              <div
                key={t._id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: "12px 14px",
                  border: "1px solid #f0f0f0",
                  borderRadius: 8,
                  marginBottom: 8,
                  background: "#fafafa",
                  gap: 12,
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Text strong style={{ display: "block", marginBottom: 2 }}>
                    {t.name}
                  </Text>
                  <Text
                    type="secondary"
                    style={{ fontSize: 12, display: "block" }}
                  >
                    {t.subject}
                  </Text>
                  {t.content && (
                    <Text
                      type="secondary"
                      style={{
                        fontSize: 12,
                        display: "block",
                        marginTop: 4,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {t.content}
                    </Text>
                  )}
                </div>

                <Popconfirm
                  title="Delete this template?"
                  description="This action cannot be undone."
                  onConfirm={() => handleDeleteTemplate(t._id)}
                  okText="Delete"
                  okButtonProps={{ danger: true }}
                  cancelText="Cancel"
                >
                  <Button
                    size="small"
                    danger
                    icon={
                      <DeleteOutlined
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    }
                    style={{ flexShrink: 0 }}
                  />
                </Popconfirm>
              </div>
            ))
          )}
        </div>
      </div>

      <CreateTemplateModal
        visible={createModalVisible}
        onClose={() => setCreateModalVisible(false)}
        templateForm={templateForm}
        onCreateTemplate={handleCreateTemplate}
        onInsertTag={insertTag}
      />
    </div>
  );
};

export default AnnouncementTemplates;
